import { Component } from '@angular/core';
import { DeviceService } from 'projects/max/dfup-storeupweb-fe/src/app/service/device.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Store up';

  constructor(public deviceSvc: DeviceService) {
  }
}
